export default "__VITE_ASSET__CgGA_etz__"